import { routeProductMap } from './configs'

/**
 * Programs opt in to the authored course tree by setting
 * `useAuthoredCourseTree: true` on their product config. When enabled, course
 * trees are fetched from the full authored structure
 * (GET /v1/course-versions/tree) instead of the audienced structure
 * (GET /v1/audienced-course-versions).
 *
 * Enabling a program here is necessary but not sufficient — each call site
 * must also opt in, so surfaces that need the audienced tree (notably the
 * `/dashboard/grades-9-12` program card) keep their current behavior even for
 * programs that are enabled here.
 *
 * @param {Object} params
 * @param {string} [params.contentGroupCode] - e.g. 'highSchool'
 * @param {string} [params.productName]      - e.g. 'high-school'
 * @returns {boolean}
 */
export function isAuthoredCourseTreeEnabled({
  contentGroupCode,
  productName,
} = {}) {
  if (!contentGroupCode && !productName) return false

  const normalizedContentGroupCode = normalize(contentGroupCode)
  const normalizedProductName = normalize(productName)

  return Object.values(routeProductMap).some(product => {
    if (!product?.useAuthoredCourseTree) return false
    if (
      normalizedContentGroupCode &&
      normalize(product.contentGroupCode) === normalizedContentGroupCode
    ) {
      return true
    }
    return (
      !!normalizedProductName &&
      normalize(product.productName) === normalizedProductName
    )
  })
}

// contentGroupCode reaches us from several sources (product config, curriculum
// -service route content, coursePointer queries) with inconsistent casing.
function normalize(value) {
  return typeof value === 'string' ? value.toLowerCase() : null
}
